import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoSirenasComponent } from './listado-sirenas/listado-sirenas.component';
import { MapaSirenasComponent } from './mapa-sirenas/mapa-sirenas.component';
import { CrearEditarSirenasComponent } from './crear-editar-sirenas/crear-editar-sirenas.component';
import { DetallesIntegracionComponent } from './detalles-integracion/detalles-integracion.component';

const routes: Routes = [
  { path: '', redirectTo: 'mapa', pathMatch: 'full' },

  //Listado
  {
    path: 'sirenas',
    title: 'Sirenas',
    component: ListadoSirenasComponent,
    canActivate: [],
  },
  // Mapa
  {
    path: 'mapa',
    title: 'Mapa de sirenas',
    component: MapaSirenasComponent,
    canActivate: [],
  },
  {
    path: 'sirenas/crear',
    title: 'Nueva sirena',
    component: CrearEditarSirenasComponent,
    canActivate: [],
  },
  {
    path: 'sirenas/editar/:id',
    title: 'Editar sirena',
    component: CrearEditarSirenasComponent,
    canActivate: [],
  },
  // Detalle de la integración (antes un diálogo). :id es el id externo (o el
  // _id o el chipId); ?cliente= para la búsqueda de respaldo.
  {
    path: 'sirenas/detalles/:id',
    title: 'Sirena',
    component: DetallesIntegracionComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SirenasRoutingModule {}
